import { eo } from "../../../../date-fns/locale/eo.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    eo
  }
};